export const OBJECT_TYPE = {
  osr: 963984,
  letters: 26508,
  jobsiteReferences: 49000,
  fwInfostore: 371800,
  productionDocuments: 3000,
}
